import request from '@/utils/request'; // 

export function dataShowAll(data) {
  return request({
    url: '/data/dataShowAll',
    method: 'get',
    params: data
  });
}